import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Accordion } from "./components/setting-accordion";
import { Input } from "./components/input";
import { SaveButton } from "./components/save-button";
import { getDaysSinceWeighIn } from "../../util";
import SettingIcon from "../../../../../../images/settings-icons/setting-calories.png";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { modifyUser } from "../../../../../../api";
import {UserCheckinWarning} from './components/user-check-in-warning'
import CheckinFormPortal from './components/check-in-2-4'
import VacationModeModal from './vacation-mode-modal'


const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Row = styled.div`
  display: flex;
  @media (max-width: 900px) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

const InputResizer = styled.div`
  max-width: 200px;
  @media (max-width: 600px) {
    max-width: 140px;
  }
`;

const FIRST_CALORIE_FLOOR_FACTOR = 22;

const getFirstCalorieFloor = (weight, bodyfat) => {
  return FIRST_CALORIE_FLOOR_FACTOR * getLBM(weight, bodyfat);
};

const getLBM = (weight, bodyfat) => {
  return weight - (weight * bodyfat) / 100;
};

const UpdateCalories = (props) => {
  const [calories, setCalories] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [showUserCheckinWarning, setShowUserCheckinWarning] = useState(false);
  const [showCheckinFormPortal, setShowCheckinFormPortal] = useState(false);
  const [showVacationModal, setShowVacationModal] = useState(false);

  useEffect(() => {
    if (props.customCalories) {
      setCalories(props.customCalories);
    }
  }, [props.customCalories]);

  const handleRestore = () => {
    setShowRestoreModal(false)
    
    if(props.vacationMode !== 0) {
      setShowVacationModal(true)
      return
    }
    
    let mods = {};
    mods["custom_calories"] = null;

    if (daysAfterLastCheckIn >= 1 && daysAfterLastCheckIn < 5) {
      setShowCheckinFormPortal(true);
    } else if (daysAfterLastCheckIn >= 5) {
      setShowUserCheckinWarning(true);
    } else if (calories < calorieFloor) {
      setShowWarningModal(true);
    } else {
      modifyUser(props.userId, props.portalId, mods).then((res) => { 
        setCalories('');
        setLoading(false);
        props.loadPortalAccount();
        props.openSnackbar('Your calories have been updated', false)
      }).catch((err) => {
        setLoading(false);
        props.loadPortalAccount();
        props.openSnackbar('Unable to update calories', true)
      });
    }
  };

  const handleSubmit = () => {
    if(props.vacationMode !== 0) {
      setShowVacationModal(true)
      return
    } else if (daysAfterLastCheckIn >= 1 && daysAfterLastCheckIn < 5) {
      setShowCheckinFormPortal(true);
    } else if (daysAfterLastCheckIn >= 5) {
      setShowUserCheckinWarning(true);
    } else if (calories < calorieFloor) {
      setShowWarningModal(true);
    } else {
      let mods = {};
      mods["custom_calories"] = calories;

      modifyUser(props.userId, props.portalId, mods).then((res) => { 
        setLoading(false);
        props.loadPortalAccount();
        props.openSnackbar('Calories have been updated', false)
        console.log('successful update')
      }).catch((err) => {
        setLoading(false);
        props.openSnackbar('Unable to update calories', true)
        console.log('failed update: ', err)
      });
    }
  };

  const calorieFloor = Number(
    getFirstCalorieFloor(props.weight, props.bodyFat).toFixed()
  );
  const disabled = calories === props.customCalories || calories === "";
  const daysAfterLastCheckIn = getDaysSinceWeighIn(props.lastWeighInDate);

  return (
    <>
      <Accordion
        show={show}
        setShow={setShow}
        icon={SettingIcon}
        settingName="Edit calories"
        currentSetting={
          props.customCalories ? `On: ${props.customCalories} calories` : "Off"
        }
        description="Change daily calorie intake"
        // alternateColor
        roundTop
      >
        <>
          <InputResizer>
            <Input onChange={(e) => setCalories(e.target.value)} value={calories} />
          </InputResizer>

          <ButtonRow>
            {/* <button onClick={() => setShowUserCheckinWarning(true)}>Show >5 days since checkin modal</button>
            <button onClick={() => setShowCheckinFormPortal(true)}>Show Checkin form</button> */}
            <Row>
              {props.customCalories &&
                <SaveButton
                  alternateColor
                  text="Restore recommended intake"
                  isLoading={isLoading}
                  onClick={() => setShowRestoreModal(true)}
                />
              }
              <SaveButton
                disabled={disabled}
                isLoading={isLoading}
                onClick={handleSubmit}
              />
            </Row>
          </ButtonRow>
        </>
      </Accordion>

      <VacationModeModal
        setting='calories'
        open={showVacationModal}
        onClose={() => setShowVacationModal(false)}
        isPaused={props.vacationMode > 0 && !props.vacationModeInfo?.practice_mode}
      />

      <UserCheckinWarning
        open={showUserCheckinWarning}
        onClose={() => setShowUserCheckinWarning(false)}
        daysAfterLastCheckIn={daysAfterLastCheckIn}
      />

      <CheckinFormPortal
        open={showCheckinFormPortal}
        onClose={() => setShowCheckinFormPortal(false)}        
        openFeedback={props.openSnackbar}
        userId={props.userId}
        portalId={props.portalId}
        loadPortalAccount={props.loadPortalAccount}
        weightString={props.weightString}
        previousWeight={props.previousWeight}
        previousBodyfat={props.previousBodyfat}
        useMetricUnits={props.useMetricUnits}
        daysAfterLastCheckIn={daysAfterLastCheckIn}
        gender={props.gender}
      />

      <Dialog
        open={showRestoreModal}
        onClose={() => setShowRestoreModal(false)}
      >
        <DialogContent className="avn-modal-content-container">
          <h4>Restore recommended intake</h4>
          <p>
            This will discard you calorie edit and restore your calories to our
            recommended intake. Are you sure you want to continue?
          </p>
        </DialogContent>
        <DialogActions className="avn-modal-actions-container">
          <button className="avn-modal-action" onClick={handleRestore}>
            Yes, please restore
          </button>
          <button
            className="avn-modal-action-cancel"
            onClick={() => setShowRestoreModal(false)}
          >
            Cancel
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showWarningModal}
        onClose={() => setShowWarningModal(false)}
      >
        <DialogContent className="avn-modal-content-container">
          <div className="avn-modal-header-container">
            <h2>Warning</h2>
          </div>
          <div className="avn-modal-header-dash"></div>
          <p>
            {`Your calorie intake is too low. Please enter a number greater than ${Math.max(
              calorieFloor - 1,
              0
            )}`}
            .
          </p>
          <p>
            Make sure your activity level is accurate, as this affects the
            number of calories you can enter.
          </p>
        </DialogContent>
        <DialogActions>
          <button
            className="avn-action-button-negative"
            onClick={() => setShowWarningModal(false)}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UpdateCalories;
